import './index.css';

import {Provider as IndicinaProvider} from '@indicina1/components-library';
import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
      <IndicinaProvider colorTheme={{
          50: "#e2ecff",
          100: "#b2c5ff",
          200: "#7f9eff",
          300: "#4e77fe",
          400: "#1d50fc",
          500: "#0335dc",
          600: "#002ab1",
          700: "#001e80",
          800: "#00124f",
          900: "#000620",
      }}>
          <App />
      </IndicinaProvider>
  </React.StrictMode>,
  document.getElementById('decide-signup-react')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
